import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { UnAuthGuard } from "./shared/guards/unAuth.guard";
import { AuthGuard } from "./shared/guards/auth.guard";
import { MobileAuthGuard } from "./shared/guards/mobileAuth.guard";
import { InfoErrorComponent } from "./shared/components/info-error/info-error.component";
import { CibilConformationComponent } from "./d2c/components/cibil-conformation/cibil-conformation.component";

const routes: Routes = [
    {
        path: "",
        redirectTo: "auth",
        pathMatch: "full",
    },
    {
        path: "auth",
        loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
    },
    {
        path: "loan",
        loadChildren: () => import("./loan-layout/loan-layout.module").then((m) => m.LoanLayoutModule),
        canActivate: [AuthGuard],
    },
    {
        path: "more-details",
        loadChildren: () => import("./more-details/more-details.module").then((m) => m.MoreDetailsModule),
    },
    {
        path: "profile",
        loadChildren: () => import("./profile-details/profile-details.module").then((m) => m.ProfileDetailsModule),
    },
    {
        path: "support",
        loadChildren: () => import("./support/support.module").then((m) => m.SupportModule),
    },
    {
        path: "history",
        loadChildren: () => import("./loan-history/loan-history.module").then((m) => m.LoanHistoryModule),
    },
    {
        path: "notifications",
        loadChildren: () =>
            import("../app/shared/components/notification/notification.module").then((m) => m.NotificationModule),
    },
    {
        path: "refer-and-earn",
        loadChildren: () => import("./refer-and-earn/refer-and-earn.module").then((m) => m.ReferAndEarnModule),
    },

    {
        path: "d2c",
        loadChildren: () => import("./d2c/d2c.module").then((m) => m.D2cModule),
        canActivate: [AuthGuard],
    },
    {
        path: "reward-wallet",
        loadChildren: () => import("./reward-wallet/reward-wallet.module").then((m) => m.RewardWalletModule),
    },
    {
        path: "emi-calculator",
        loadChildren: () => import("./emi-calculator/emi-calculator.module").then((m) => m.EmiCalculatorModule),
    },
    {
        path: "info",
        component: InfoErrorComponent,
    },
    {
        path: "coming-soon",
        component: InfoErrorComponent,
    },
    {
        path: "cibil-confirmation",
        component: CibilConformationComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    providers: [AuthGuard, UnAuthGuard, MobileAuthGuard],
    exports: [RouterModule],
})
export class AppRoutingModule {}
